import cn from 'classnames'
import styled, { keyframes, ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'

const spinDelay = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

const SpinWrapper = styled.div.withConfig({
  shouldForwardProp: prop => !['delay', 'alignItems', 'justifyContent'].includes(prop),
})`
  padding: 20px;
  &.isSearching {
    padding: 4px 5px;
    display: flex;
    align-items: center;
  }
  .spinner {
    display: inline-block;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    border: 4px solid ${props => props.theme.palette.secondary.main};
    border-top-color: ${props => props.theme.palette.primary.main};
    animation: ${spinDelay} ${props => props.delay}ms infinite linear;
    &.searching {
      width: 22px;
      height: 22px;
      border-width: 2px;
      border-color: ${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`};
      border-top-color: ${props => props.theme.palette.primary.main};
    }
  }
`

const Spinner = ({ delay, searching, ...rest }) => (
  <ThemeProvider theme={theme}>
    <SpinWrapper
      delay={delay}
      alignItems="center"
      justifyContent="center"
      className={cn({ isSearching: searching })}
      {...rest}
    >
      <div className={cn('spinner', { searching })} />
    </SpinWrapper>
  </ThemeProvider>
)

Spinner.displayName = 'Spinner'

Spinner.defaultProps = {
  delay: 1000,
  searching: false,
}

export default Spinner
